export enum ContextTypes {
	WEB = 1,
  APP = 2
}
